import React from 'react';
import styled from 'styled-components';
import { GatsbyImage } from 'gatsby-plugin-image';

import Text from './Text';
import HTMLWrapper from './HTMLWrapper';
import documentToReactComponents from '../util/documentToReactComponents';

import theme from '../../styles/theme';

const {
	breakPoints: { screenQuery },
} = theme;

const GuestWrapper = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: 150px 1fr;
	align-content: center;

	.guest-description {
		display: flex;
		flex-wrap: wrap;
		align-content: center;
		> * {
			width: 100%;
		}
	}
	margin-bottom: 40px;

	${screenQuery.medium} {
		grid-template-columns: 1fr;
	}
`;

const GuestImgWrapper = styled.div`
	background: url(${props => props.image});
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
	border-radius: 50%;
	height: 125px;
	width: 125px;

	img {
		border-radius: 50%;
		aspect-ratio: 1 / 1;
	}

	.sr-only {
		position: absolute;
		width: 1px;
		height: 1px;
		padding: 0;
		margin: -1px;
		overflow: hidden;
		clip: rect(0, 0, 0, 0);
		border: 0;
	}
`;

export default ({ image, title, description, hideTitle, ...props }) => {
	return (
		<GuestWrapper key={title} {...props}>
			<GuestImgWrapper image={image}>
				{image.gatsbyImageData ? (
					<GatsbyImage
						image={image.gatsbyImageData}
						alt={`Picture of your guest, ${title}`}
					/>
				) : (
					<img
						src={image}
						className="sr-only"
						alt={`Picture of your guest, ${title}`}
					/>
				)}
			</GuestImgWrapper>
			<div className="guest-description">
				{title && !hideTitle && <Text component="h4">{title}</Text>}
				{description && (
					<Text component="b3">
						<HTMLWrapper
							css={{
								p: {
									fontSize: '.88em',
								},
							}}
						>
							{documentToReactComponents(description)}
						</HTMLWrapper>
					</Text>
				)}
			</div>
		</GuestWrapper>
	);
};
